import type { PostHog } from 'posthog-js'

export const usePosthog = () => {
  const { $posthog } = useNuxtApp()
  
  const posthog = $posthog() as PostHog | null
  
  // Helper methods for common PostHog operations
  const capture = (eventName: string, properties?: Record<string, any>) => {
    if (posthog) {
      posthog.capture(eventName, properties)
    }
  }
  
  const identify = (userId: string, properties?: Record<string, any>) => {
    if (posthog) {
      posthog.identify(userId, properties)
    }
  }
  
  const reset = () => {
    if (posthog) {
      posthog.reset()
    }
  }
  
  const setPersonProperties = (properties: Record<string, any>) => {
    if (posthog) {
      posthog.setPersonProperties(properties)
    }
  }
  
  const group = (groupType: string, groupKey: string, properties?: Record<string, any>) => {
    if (posthog) {
      posthog.group(groupType, groupKey, properties)
    }
  }
  
  const feature_flag = (flagKey: string) => {
    if (posthog) {
      return posthog.isFeatureEnabled(flagKey)
    }
    return false
  }
  
  return {
    posthog,
    capture,
    identify,
    reset,
    setPersonProperties,
    group,
    feature_flag,
    isEnabled: !!posthog
  }
} 